<template>
    <div class="stripe-field-wrapper">
        <div class="stripe-field-container select-container" v-bind:class="fieldClass">
            <select :required="required" @change="handleInput" ref="select" class="stripe-field">
                <option value="">State</option>
                <option
                    v-for="state in states"
                    v-bind:value="state.state_id"
                    v-bind:selected="value == state.state_id"
                    v-if="state.country_id == countryid"
                >
                    {{ state.state_name }}
                </option>
            </select>
        </div>
        <div class="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: 'checkout-state-select',
    props: {
        'value': {
            type: String
        },
        'required': {
            type: Boolean,
            default: true
        },
        'states': {
            type: Array
        },
        'countryid': {
        }
    },
    data() {
        return {
            error: ''
        }
    },
    methods: {
        validate () {
            this.error = "";
            var value = this.$refs.select.value;
            if(!value && this.required) {
                this.error = "This is a required field";
            }
        },
        handleInput () {
            this.validate();
            var value = this.$refs.select.value;
            this.$emit('input', value);
        }
    },
    computed: {
        fieldClass: function(component) {
            return {
                'validation-failed': this.error != ''
            }
        }
    }
};
</script>